import {Alert, Button, Spinner} from "reactstrap";
import {useDownloadCertificate} from "./useDownloadCertificate";

type Props = {
  eventId: string | undefined;
  disabled: boolean;
  isFetching: boolean;
  onRetry: () => unknown;
};

export function CertificateReadError({eventId, disabled, isFetching, onRetry}: Props) {
  const {downloadCertificate, isDownloadingCertificate, downloadCertificateError} =
    useDownloadCertificate(eventId);

  return (
    <Alert color="warning" role="alert">
      Impossible de charger l'attestation.
      <div className="d-flex gap-2 flex-wrap mt-2">
        <Button color="secondary" outline onClick={onRetry} disabled={disabled || isFetching}>
          {isFetching && <Spinner size="sm" />} Réessayer
        </Button>
        <Button
          color="primary"
          onClick={downloadCertificate}
          disabled={disabled || isDownloadingCertificate}
        >
          {isDownloadingCertificate && <Spinner size="sm" />} Télécharger le PDF existant
        </Button>
      </div>
      {downloadCertificateError && (
        <div className="mt-2" role="alert">
          {downloadCertificateError}
        </div>
      )}
    </Alert>
  );
}
